import { RadarTargetInfo } from '@ais-ui/websockets';
import React from 'react';
import { useSettings } from '../../Settings/SettingsProvider';
import { useDateTimeFormat } from '../../conversions/useDateFormat';
import {
  InfoTooltipFields,
  type TooltipFieldDefinition,
} from './InfoTooltipFields';

interface RadarInfoTooltipProps {
  radarInfo: RadarTargetInfo;
}

export const RadarInfoTooltip = ({ radarInfo }: RadarInfoTooltipProps) => {
  const { settings } = useSettings();
  const { formatDateTimeWithTimeZone } = useDateTimeFormat();
  const ribbonSettings = settings['ribbonPlugin.settings'];

  const fields: TooltipFieldDefinition[] = [
    {
      key: 'id',
      label: 'ID',
      value: radarInfo.id,
      visible: ribbonSettings?.show_radar_id,
    },
    {
      key: 'name',
      label: 'Name',
      value: radarInfo.name,
      visible: ribbonSettings?.show_radar_name,
    },
    {
      key: 'sog',
      label: 'SOG',
      value: radarInfo.sog,
      visible: ribbonSettings?.show_radar_sog,
    },
    {
      key: 'cog',
      label: 'COG',
      value: radarInfo.cog,
      visible: ribbonSettings?.show_radar_cog,
    },
    {
      key: 'lastRadarReport',
      label: 'Last Report',
      value: radarInfo.lastRadarReport
        ? formatDateTimeWithTimeZone(radarInfo.lastRadarReport)
        : undefined,
      visible: ribbonSettings?.show_radar_last_report,
    },
    {
      key: 'lastOrigin',
      label: 'Last Origin',
      value: radarInfo.lastOrigin,
      visible: ribbonSettings?.show_radar_last_origin,
    },
    {
      key: 'latitude',
      label: 'Latitude',
      value: radarInfo.latitude,
      visible: ribbonSettings?.show_radar_latitude,
    },
    {
      key: 'longitude',
      label: 'Longitude',
      value: radarInfo.longitude,
      visible: ribbonSettings?.show_radar_longitude,
    },
  ];

  return <InfoTooltipFields fields={fields} />;
};
